const Distribution = () => {
    return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Distribution
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              When customers choose TCS to fulfil their distribution needs, they choose scalability and flexibility in the 
              form of one of the largest fleets of primary and secondary distribution transportation and strategically 
              located distribution hubs across the country. We take into account every relevant factor, such as inventory, 
              storage spaces and MSDS. Our cloud-based warehouse management system with a suite of innovative applications 
              enables manufacturers and retailers to monitor and stay on top of their supply chain processes.
            </p>
            {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              We take into account every relevant factor, such as inventory, storage spaces and MSDS. 
              Along with an extensive nationwide network, a broad suite of innovative applications enables manufacturers and
               retailers to monitor and stay on top of their supply chain processes through cloud-based warehouse management systems.

            </p> */}
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/scrolling-image21.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
        
           
    
      </div>
    </div>
    

  )
};
export default Distribution;